"use client";

import Link from "next/link";

export default function EventDetailError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-screen bg-[#0b0c0f] text-white">
      <div className="mx-auto flex min-h-screen w-full max-w-[720px] flex-col items-start justify-center px-6 py-16">
        <p className="text-xs uppercase tracking-[0.35em] text-white/50">
          Event error
        </p>
        <h1 className="mt-3 text-3xl font-heading">
          Something went wrong loading this event.
        </h1>
        <p className="mt-3 text-sm text-white/60">
          {error?.message || "An unexpected error occurred. Please try again."}
        </p>
        <div className="mt-6 flex items-center gap-4">
          <button
            onClick={reset}
            className="rounded-full bg-white/10 px-6 py-3 text-xs font-bold uppercase tracking-[0.35em] text-white transition-colors hover:bg-white/20"
          >
            Try again
          </button>
          <Link
            href="/"
            className="rounded-full px-6 py-3 text-xs font-bold uppercase tracking-[0.35em] text-white/60 transition-colors hover:text-white"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}
